import React, { useState } from 'react';
import { Upload, FileText } from 'lucide-react';
import { AppContext } from '../AppContext';

export default function TextUploader() {
  const [textFile, setTextFile] = useState<File | null>(null);
  const { input: transcript, setInput: setTranscript } = React.useContext(AppContext);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && file.type === 'text/plain') {
      setTextFile(file);
      const content = await file.text();
      setTranscript(content);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center w-full h-full bg-gray-50 p-8">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Text File Upload</h2>
          <p className="text-gray-600">Upload and view your text files</p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors">
            <div className="flex flex-col items-center justify-center pt-5 pb-6">
              <Upload className="w-10 h-10 mb-3 text-gray-400" />
              <p className="mb-2 text-sm text-gray-500">
                <span className="font-semibold">Click to upload</span> or drag and drop
              </p>
              <p className="text-xs text-gray-500">Text files (.txt)</p>
            </div>
            <input
              type="file"
              className="hidden"
              accept=".txt"
              onChange={handleFileChange}
            />
          </label>

          {textFile && (
            <div className="mt-6">
              <div className="flex items-center justify-between bg-gray-100 p-4 rounded-lg">
                <div className="flex items-center space-x-3">
                  <FileText className="w-5 h-5 text-gray-600" />
                  <span className="text-sm font-medium text-gray-700 truncate">
                    {textFile.name}
                  </span>
                </div>
              </div>
              <div className="mt-4 p-4 bg-gray-50 border border-gray-300 rounded-lg overflow-auto max-h-64">
                <pre className="text-sm text-gray-700 whitespace-pre-wrap">{(typeof transcript === 'string') ? transcript : ''}</pre>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}